
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/toaster";
import { ErrorBoundary } from "@/components/ErrorBoundary";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { AssessmentProvider } from "@/contexts/AssessmentContext";
import { AuthProvider } from "@/contexts/AuthContext";
import { ProtectedRoute } from "@/components/auth/ProtectedRoute";
import HomePage from "@/pages/HomePage";
import About from "@/pages/About";
import Assessment from "@/pages/Assessment";
import Methodology from "@/pages/Methodology";
import NotFound from "@/pages/NotFound";
import AssessmentHistory from "@/pages/AssessmentHistory";
import AssessmentDetail from "@/pages/AssessmentDetail";
import MasterAssessmentHistory from "@/pages/MasterAssessmentHistory";
import Navbar from "@/components/Navbar";
import Login from "@/pages/Login";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 1000 * 60 *
      5, // 5 minutes
      gcTime: 1000 * 60 * 30, // 30 minutes
    },
  },
});

function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <ErrorBoundary>
        <Router>
          <AuthProvider>
            <AssessmentProvider>
              <div className="flex flex-col min-h-screen">
                <Navbar />
                <main className="flex-1">
                  <Routes>
                    <Route path="/" element={<HomePage />} />
                    <Route path="/about" element={<About />} />
                    <Route path="/methodology" element={<Methodology />} />
                    <Route path="/login" element={<Login />} />
                    
                    {/* Protected Routes */}
                    <Route 
                      path="/assessment" 
                      element={
                        <ProtectedRoute>
                          <Assessment />
                        </ProtectedRoute>
                      } 
                    />
                    <Route 
                      path="/assessment-history" 
                      element={
                        <ProtectedRoute>
                          <AssessmentHistory />
                        </ProtectedRoute>
                      } 
                    />
                    <Route 
                      path="/assessment-history/:id" 
                      element={
                        <ProtectedRoute>
                          <AssessmentDetail />
                        </ProtectedRoute>
                      } 
                    />
                    <Route 
                      path="/admin/assessment-history" 
                      element={
                        <ProtectedRoute>
                          <MasterAssessmentHistory />
                        </ProtectedRoute>
                      } 
                    />
                    
                    <Route path="*" element={<NotFound />} />
                  </Routes>
                </main>
                <Toaster />
              </div>
            </AssessmentProvider>
          </AuthProvider>
        </Router>
      </ErrorBoundary>
    </QueryClientProvider>
  );
}

export default App;
